/**
 * /frontend/src/features/analytics/components/bottleneck/SectionComparisonChart.js
 */

import React, { useMemo } from 'react';
import ChartContainer from '../shared/ChartContainer';
import GroupedBarChart from '../charts/GroupedBarChart';
import { CHART_COLORS } from '../../constants/chartColors';

/**
 * Grouped bar chart for section comparison.
 * @param {{data:Array<{sectionName:string,avgWaitMinutes:number,avgServiceMinutes:number,throughputPerHour:number}>}} props
 * @returns {JSX.Element}
 */
const SectionComparisonChart = ({ data }) => {
  const bars = useMemo(() => ([
    { key: 'avgWaitMinutes', label: 'Avg wait (min)', color: CHART_COLORS.accent },
    { key: 'avgServiceMinutes', label: 'Service (min)', color: CHART_COLORS.accentStrong },
    { key: 'throughputPerHour', label: 'Throughput/hr', color: CHART_COLORS.cyan }
  ]), []);

  return (
    <ChartContainer title="Section Comparison" subtitle="Wait, service, throughput by section">
      <GroupedBarChart data={data} xKey="sectionName" bars={bars} />
    </ChartContainer>
  );
};

export default SectionComparisonChart;
